module.exports = __webpack_public_path__ + "f2d8adb528f8d99108da76c8e6f1d5d4.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/colossal_clashes-420.webp.png
// module id = 228
// module chunks = 0